import { createContext } from 'react'

const DeviceContext = createContext({
  isMobile: false,
  setIsMobile: () => {},
})

export default DeviceContext
